import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  HStack,
  Text,
  Icon,
} from '@chakra-ui/react';
import { FiGlobe, FiChevronDown } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useLanguageStore, SupportedLanguage } from '@/stores/languageStore';

const LanguageSelector: React.FC = () => {
  const { t } = useTranslation();
  const { currentLanguage, setLanguage, getLanguageLabel } = useLanguageStore();

  const languages: SupportedLanguage[] = ['en', 'tr', 'ar'];

  const handleLanguageChange = (language: SupportedLanguage) => {
    setLanguage(language);
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="ghost"
        size="sm"
        rightIcon={<FiChevronDown />}
        leftIcon={<FiGlobe />}
      >
        <Text display={{ base: 'none', md: 'block' }}>
          {getLanguageLabel(currentLanguage)}
        </Text>
      </MenuButton>
      <MenuList>
        <Text px={3} py={2} fontSize="sm" fontWeight="medium" color="gray.500">
          {t('language.selectLanguage')}
        </Text>
        {languages.map((language) => (
          <MenuItem
            key={language}
            onClick={() => handleLanguageChange(language)}
            bg={currentLanguage === language ? 'blue.50' : 'transparent'}
            color={currentLanguage === language ? 'blue.600' : 'inherit'}
            fontWeight={currentLanguage === language ? 'medium' : 'normal'}
          >
            <HStack spacing={3}>
              <Text>{getLanguageLabel(language)}</Text>
              {currentLanguage === language && (
                <Icon as={FiGlobe} color="blue.500" boxSize={4} />
              )}
            </HStack>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default LanguageSelector; 